import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import styles from './JobDetailsTab.module.css';
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from "../../../assets/dummy.png";
import moment from "moment";

const JobDetailsTab = () => {
  const navigate = useNavigate();


  useEffect(() => {
    getJobDetails();
    getLanguage();
  }, [])

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const CreateJobDetailsList = useSelector(
    state => state.JobDetailsReducer.CreateJobDetailsList,
  );

  const CreateJobDetailsPagination = useSelector(
    state => state.JobDetailsReducer.CreateJobDetailsPagination,
  );


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getJobDetails = () => {
    const data = {
      next_page_url: undefined,
    };
    dispatch(CustomerMiddleware.getJobDetails(data));
  };
  const onPressLoadMore = () => {
    let data = {
      next_page_url: CreateJobDetailsPagination?.links?.next,
    };
    dispatch(CustomerMiddleware.getJobDetails(data));
  };

  const loadMore =
    CreateJobDetailsPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const options = [
    {
      id: 1,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
    {
      id: 2,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
    {
      id: 3,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
    {
      id: 4,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
    {
      id: 5,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
    {
      id: 6,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      location: 'Los Angeles,New',
      fromTime: '08:39 PM',
      toTime: '09:39 PM',
    },
  ];
  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/contractorHome/Customers/JobDetails", {
            state: item,
          })
        }
      >
        <img src={item?.customer_image ? IMG_URL + item?.customer_image : dummyImg} className={styles.image} />
        <div className={styles.heading_view}>
          <text className={styles.tab_heading}> {item?.customer_name}</text>
          <text className={styles.text}>{t(item?.service_type)}</text>
          <text className={styles.text}>{item?.location?.street},{item?.location?.state}</text>
          <text className={styles.text}>{moment('01 jan 1940 ' + item?.start_time).format(
            'hh:mm A',
          ) +
            ' To ' +
            moment('01 jan 1940 ' + item?.end_time).format(
              'hh:mm A',
            )}</text>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainCon}>
      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={CreateJobDetailsList}
        footer={loadMore}
        renderItem={renderItem}
      />
    </div>
  )
};
export default JobDetailsTab;